export const config = {
  app: "pho",
  appTitle: "PHO.ai - AI Enabled Product Health Optimization",
  appFavicon: "assets/images/faviconpho.ico",
  supportMailID: "pho.product.team@ab-inbev.com",
};
